<template>
	<div class="templatebody" :style="note">
		<div>
			<Userheard></Userheard>
		</div>
		<!-- 查询1 -->
		<div class="back-color-white  align-content query-form-table search">
			<div>
				<p class="text-silver" style="font-size:18px ;margin-left:94px">
					可查询关键字：运单号/状态/航班号/起降机场/目的港</p>
			</div>
			<div>
				<el-input placeholder="" suffix-icon="el-icon-search" v-model="input2" @keydown.enter.native="find">
				</el-input>
			</div>
			<div class=" " style="margin-right:57px ">
				<el-button type="success" @click="find" class="btn">运单查询
				</el-button>
				<el-button type="success " @click='backSet' class="btn">内容重置
				</el-button>
			</div>
		</div>
		<!-- 列表内容 -->
		<div class="back-color-white query-form-tables tap">
			<!-- 列表 -->
			<div class="query-form-table-border" v-for="(i,index) in  tableData" :key='index' @click="go(i.order_no)">
				<!-- 列 -->
				<div class="flex-juspace align-content query-form-list">
					<!-- 状态和单号 -->
					<div class="leftp query-form-list-border-right" style="width: 20%;">

						<p class="tag">{{i.state}}</p>
						<p class="mxp padding-top-lt text-dackblue" style="font-size:20px;">
							{{i.order_no}}</p>
					</div>
					<!-- 机场和地址 -->
					<div class="flex-all-center tap" style="width: 60%;">
						<div style="width: 42%;margin-top:5px ">
							<p style="font-size: 20px ;" v-if='i.depart_port_name'>
								{{i.depart_port_name}}（{{i.depart_port}}）</p>
							<p style="font-size: 16px ;width:95%">{{i.depart_time }}</p>
						</div>
						<div style="width: 16%;">
							<div class="flight-border">
								<p style="font-size: 5px;margin-top:18px ">{{i.voyage_name}}
								</p>
							</div>
							<div style="padding-top: 3%;">
								<p style="font-size: 18px;">{{i.voyage_number}}</p>
							</div>
						</div>
						<div style="width: 42%;padding-left: 1%;margin-top:5px ">
							<p class="font1" v-if="i.arrive_port">{{i.arrive_port_name}}（{{i.arrive_port}}）</p>
							<p class="font2" style="width:95%">{{i.arrive_time}}</p>
						</div>
					</div>
					<!-- 重量和时间 -->
					<div class="leftp query-form-list-border-left" style="width: 20%;">
						<p style="font-size: 16px ;padding-bottom:2%" v-if="i.order_weight">
							订舱重量：{{i.order_weight}} KG</p>
						<p style="font-size: 16px ;padding-bottom:2%" v-else>订舱重量：0 KG</p>
						<p class="padding-top-lt mxp" style="font-size: 16px;">创建时间：{{i.create_time}}
						</p>
					</div>
				</div>

			</div>
			<!-- 分页 -->
			<div style="padding-top: 2%;">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page="page" :page-sizes="[5, 10, 20, 50]" :page-size="pagesize"
					layout="total, sizes, prev, pager, next, jumper" :total="total">
				</el-pagination>
			</div>
		</div>
		<div class="buttom-text">
			<p>版权所有：海南云航翊信息科技有限责任公司 Copyright © 2014.Company name All rights reserved.</p>

		</div>
		<div class="box"></div>
	</div>
</template>

<script>
import '@/assets/css/user.css'
import '@/assets/css/public.css'
import Userheard from '../public/Userheard.vue'
export default {
  components: {
    Userheard
  },
  data () {
    return {
      note: {
        backgroundImage: 'url(' + require('../../assets/img/bg-login.jpg') + ')',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100%',

        width: '100%',
        height: '100%'
      },
      page: 1,
      input2: '',
      pagesize: 5,
      tableData: [],
      total: 0
    }
  },
  mounted () {

  },
  methods: {

    backSet () {
      this.input2 = ''
    },
    find () {
      this.page = 1
      this.getList(this.input2)
    },
    go (id) {
      this.$router.push({
        name: 'ladingmessage',
        params: {
          id: id
        }
      })
    },

    handleSizeChange (val) {
      this.pagesize = val
      this.getList(this.input2)
    },
    handleCurrentChange (val) {
      this.page = val
      this.getList(this.input2)
    },
    getList (content) {
      let id = JSON.parse(localStorage.getItem('userInfo')).servicer_id
      this.$source.post('/v1/flight_order/info', {
        service_id: id,
        page_no: this.page,
        page_num: this.pagesize,
        text: content
      }).then(res => {
        this.tableData = res.body.data.order_list
        this.total = res.body.data.num
      })
    }
  },
  created () {
    this.getList()
  }
}
</script>
<style scoped>
.btn {
	background: rgb(253, 148, 5);
	border: none;
}

.buttom-text {}

.el-form-item__label {
	font-size: 18px;
	color: #FFFFFF;
}

.el-tag--dark {
	background-color: #3F6E88;
	border-color: #3F6E88;
	color: #fff;
}

.templatebody {
	min-height: 95vh;
}

.query-form-list-border-right>>>.el-tag--dark {
	font-size: 18px;
	text-align: center;
	line-height: 30px;
	height: 30px;

}

.query-form-table-border {
	border: none;
}

.font1 {
	font-size: 20px;
}

.font2 {
	font-size: 16px;
}

.tag {
	width: 95px;
	height: 30px;
	background: rgb(62, 111, 134);
	text-align: center;
	color: #fff;
	line-height: 30px;
	border-radius: 5px;
	font-size: 15px;
}

.tap:hover {
	cursor: pointer;
}

.search {
	display: flex;
	justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/components/user/ordermanage.vue